import { useAuthenticator } from '@aws-amplify/ui-react'
import Cookies from 'js-cookie'
import { useState } from 'react'

const PROFILE_KEY = 'classrankedUserProfile'

interface AuthUserProfile {
  email: string
  firstName: string
  middleName?: string
  lastName: string
  name: string
  student_id?: string
  user_id: string
}

interface UseProfile {
  isAuthed: () => boolean
}

export default function useProfile (): UseProfile {
  const defaultVal = localStorage.getItem(PROFILE_KEY)
  const [user, setUser] = useState<AuthUserProfile | null>(defaultVal !== null && defaultVal !== null ? JSON.parse(defaultVal) : null)

  const { route } = useAuthenticator((context) => [context.route])

  function isAuthed (): boolean {
    return route === 'authenticated' || route === 'setup' || Cookies.get('edlink_access_token_exists') != null
  }

  return {
    isAuthed
  }
}
